import featureFlags from './featureFlags';

export const getStripePublishableKey = () => {
  if (featureFlags.getEnvironment() !== 'production') {
    return 'pk_test_kLypsQNKVwzP5Jshbh2vMFCw';
  }
  return 'pk_live_dBZkow17g2crlYlMLxfafwYt';
};
